export const enum EventBusEvent {
  ToggleSideNav = 'TOGGLE_SIDE_NAV',
  WishlistCounterUpdate = 'update.wishlist:counter',
  CartCounterUpdate = 'update.header:cart',
  AddAlerts = 'ADD_ALERT',
  ShowEmptyCart = 'SHOW_EMPTY_CART',
  ToggleDrawer = 'TOGGLE_DRAWER',
  ReclamationRequestListChange = 'RECLAMATION_REQUEST_LIST_CHANGE',
  ReclamationDrawerToggle = 'RECLAMATION_DRAWER_TOGGLE',
  ReclamationImageGalleryToggle = 'RECLAMATION_IMAGE_GALLERY_TOGGLE',
  ReclamationUploadedPicturesStateChange = 'RECLAMATION_UPLOADED_PICTURES_STATE_CHANGE',
  CheckoutButtonState = 'CHECKOUT_BUTTON_STATE',
  CheckoutButtonStateTaxId = 'CHECKOUT_BUTTON_STATE_TAX_ID',
  ToggleCategoriesDrawer = 'TOGGLE_CATEGORIES_DRAWER',
  ToggleCategoryFiltersDrawer = 'TOGGLE_CATEGORY_FILTERS_DRAWER',
  ToggleAlert = 'TOGGLE_ALERT',
  ToggleCheckoutAlert = 'TOGGLE_CHECKOUT_ALERT',
  OnCheckoutErrorMessage = 'ON_CHECKOUT_ERROR_MESSAGE',
  OpenModel3D = 'OPEN_MODEL_3D',
  OpenSketchOverlay = 'OPEN_SKETCH_OVERLAY',
  BottomDrawerUpdate = 'BOTTOM_DRAWER_UPDATE',
  CartUpdate = 'CART_SUMMARY_UPDATE',
  MyProfileAlert = 'MY_PROFILE_ALERT',
  GiftCardsUpdate = 'GIFT_CARDS_UPDATE',
  CartProductListUpdate = 'CART_PRODUCT_LIST_UPDATE',
  SavedProductListUpdate = 'SAVED_PRODUCT_LIST_UPDATE',
  TogglePaymentSelectionDrawer = 'TOGGLE_PAYMENT_SELECTION_DRAWER',
  VoucherUpdate = 'VOUCHER_UPDATE',
  ArticleShippingDataUpdate = 'ARTICLE_SHIPPING_DATA_UPDATE',
  ToggleDrawerOverlay = 'TOGGLE_DRAWER_OVERLAY',
  ZipCodeUpdate = 'ZIP_CODE_UPDATE',
  AdditionalServicesUpdate = 'ADDITIONAL_SERVICES_UPDATE',
  UserAccountUpdate = 'USER_ACCOUNT_UPDATE',
  StickyState = 'STICKY_STATE',
  ShowSnackbar = 'SHOW_SNACKBAR',
  ToggleCoupon = 'TOGGLE_COUPON',
  UrlUpdate = 'URL_UPDATE',
}
